import classNames from "classnames"
import React from "react"
import { createImageFromInitials } from "../../utils/UserInitialsUtils"
import "./User.scss"

type UserProps = {
  name: string
  picture?: string | null
  className?: string
  isGuest?: boolean
  size?: "xxs" | "medium"
} & React.HTMLAttributes<HTMLDivElement>

function User({ name, picture, className, isGuest, size, ...rest }: UserProps) {
  const usedClassName = classNames(
    "User",
    {
      "User--xxs": size === "xxs",
      "User--medium": size === "medium",
    },
    className,
  )

  return (
    <div
      className={usedClassName}
      title={name}
      style={{
        background:
          "#f2d7ca url(" +
          (picture ? picture : createImageFromInitials(500, name, isGuest)) +
          ") 0% 0% / cover",
      }}
      {...rest}
    />
  )
}

export default User
